// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIsOrphanedPropertyDto
 */
export interface IIsOrphanedPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IIsOrphanedPropertyDto
     */
    is_orphaned?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IIsOrphanedPropertyDto
     */
    is_orphaned_state?: IIsOrphanedPropertyDtoIsOrphanedStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIsOrphanedPropertyDtoIsOrphanedStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IIsOrphanedPropertyDto interface.
 */
export function instanceOfIIsOrphanedPropertyDto(value: object): value is IIsOrphanedPropertyDto {
    return true;
}

export function IIsOrphanedPropertyDtoFromJSON(json: any): IIsOrphanedPropertyDto {
    return IIsOrphanedPropertyDtoFromJSONTyped(json, false);
}

export function IIsOrphanedPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIsOrphanedPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_orphaned': json['is_orphaned'] == null ? undefined : json['is_orphaned'],
        'is_orphaned_state': json['is_orphaned_state'] == null ? undefined : json['is_orphaned_state'],
    };
}

export function IIsOrphanedPropertyDtoToJSON(json: any): IIsOrphanedPropertyDto {
    return IIsOrphanedPropertyDtoToJSONTyped(json, false);
}

export function IIsOrphanedPropertyDtoToJSONTyped(value?: IIsOrphanedPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_orphaned': value['is_orphaned'],
        'is_orphaned_state': value['is_orphaned_state'],
    };
}

